// @ts-check
import React from 'react';
import { SettingsNav } from './SettingsNav';
import styles from './EntitySettings.module.scss';

const EntitySettings = ({ entity, children, params: { entityId } }) => (
  <div className={styles.container}>
    <div className={styles.nav_container}>
      <SettingsNav entity={entity} />
    </div>
    <div className={styles.content_container}>{children}</div>
  </div>
);

export default EntitySettings;
